import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import {
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import { RegistrationWarrantyNotePanelComponentService } from '../../services/registration-warranty-note-panel/registration-warranty-note-panel.service';
import { translation } from './i18n/translation.constant';

@Component({
  selector: 'us-registration-warranty-note-panel',
  standalone: true,
  imports: [AsyncPipe, NgIf, IconComponent, NgClass, TranslatePipe],
  styleUrls: ['./registration-warranty-note-panel.component.scss'],
  template: `
    <ng-container *ngIf="cs.vm$ | async as vm">
      <div
        *ngIf="vm.hasRegisteredItemOutOfGuarantee"
        [ngClass]="spacingClass"
        class="registration-warranty-note-panel p-5"
      >
        <div class="registration-warranty-note-panel__header">
          <p class="registration-warranty-note-panel__header-title pb-4">
            {{ 'REGISTRATION_WARRANTY_NOTE_PANEL_TITLE' | translate }}
          </p>
          <div class="registration-warranty-note-panel__header-icon">
            <dgx-components-icon [icon]="'info-circle'" size="md" />
          </div>
        </div>
        <p class="mb-3">
          {{ 'REGISTRATION_WARRANTY_NOTE_PANEL_WAITING_PERIOD' | translate }}
        </p>
        <p>
          {{ 'REGISTRATION_WARRANTY_NOTE_PANEL_CLAIM_UNDER_PLAN' | translate }}
        </p>
      </div>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    provideTranslationDictionaryMapping(translation),
    RegistrationWarrantyNotePanelComponentService,
  ],
})
export class RegistrationWarrantyNotePanelComponent {
  @Input() spacingClass?: string;

  constructor(readonly cs: RegistrationWarrantyNotePanelComponentService) {}
}
